import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { MediaProfileContext } from "../../data/media_profile_context_management";
import useMediaJobsApi from "../../data/use_media_jobs_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
import PublicationsEditorActive from "./PublicationsEditorActive";

const PUBLICATIONS_ERROR_LABELS = { started_at: "Start date", ended_at: "End date", title: "Title" };

// Publications (media jobs) edit body — the media sibling of pr_profiles' EmploymentModalBody. Reads the
// mediaJobs collection + plumbing straight from MediaProfileContext (the provider owns the collection —
// no modal-local fetch or loading state) and performs writes via use_media_jobs_api. Same context-based
// shape as HeaderModalBody.
function PublicationsModalBody({ close }) {
  const context = useContext(MediaProfileContext);
  const { mediaJobs, generalError, isUpdating } = context;
  const { addMediaJob, removeMediaJob, updateMediaJob } = useMediaJobsApi({ ...context });

  const publicationsState = { mediaJobs, addMediaJob, removeMediaJob, updateMediaJob, isUpdating };

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} labelMap={PUBLICATIONS_ERROR_LABELS} />
        <PublicationsEditorActive publicationsState={publicationsState} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default PublicationsModalBody;
